// extracted by mini-css-extract-plugin
export default {"cover_letter":"CoverLetter_cover_letter__BX-a5","cl_textarea":"CoverLetter_cl_textarea__41+kZ","cl_text":"CoverLetter_cl_text__abtM7"};